// extracted by mini-css-extract-plugin
module.exports = {"primary":"ButtonWrap_primary__2AdxE","secondary":"ButtonWrap_secondary__3-zcS","tertiary":"ButtonWrap_tertiary__2KFXo"};